import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalConfig } from 'src/app/utils/common/global-config/global-config';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/utils/services/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthLoginResponse } from 'src/app/utils/models/auth/auth-login/auth-login-response.model';
import { TokenResponse } from 'src/app/utils/models/token-response/token-response.model';
import { UserInformationsResponse } from 'src/app/utils/models/profile/user-info-response.model';
import { LocationExtension } from 'src/app/utils/common/LocationExtension';
import { AasValidateMessage } from 'src/app/utils/common/validate-msg-aas';
import { AasConsumerManagerService } from 'src/app/utils/services/aas-network/aas-consumer-manager.service';
import { FirebaseService } from 'src/app/utils/services/aas-network/firebase/firebase.service';
import { NotificationsService } from 'src/app/utils/services/aas-network/notifications.service';
import { PackageSessionService } from 'src/app/utils/services/aas-network/package-session/package-session.service';
import { ConstantAlertBtn, ConstantAlertMsg } from 'src/app/utils/common/constant-alert-msg';
import { ConstantAlertType } from 'src/app/utils/common/constant-alert-type';
import { AlertComponent } from 'src/app/layout/extensions/alert/alert.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseMsg } from 'src/app/utils/common/response-msg-aas';
import { InfoPartyObject } from 'src/app/utils/models/aas-models/info-party/info-party-object';
import { UserInformationsItem } from 'src/app/utils/models/profile/user-info-item.model';
import { ConstLocalStorage } from 'src/app/utils/common/constant';
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs";
import { AlertControl } from 'src/app/utils/alert/alert-control';
import { REGEXP_USERNAME } from 'src/app/utils/common/regexp';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {

  redirectUrl = this.activedRoute.snapshot.queryParamMap.get('redirectUrl') || '';
  domain = this.activedRoute.snapshot.queryParamMap.get('domainname');

  loginForm: FormGroup;
  isSubmit = false;
  loginFailed = false;

  token = new AuthLoginResponse();
  tokenResponse = new TokenResponse();
  userInfo = new UserInformationsResponse();
  partyId = '';
  isLoading = false;
  saveLogin = true;

  validateMsg = AasValidateMessage.LOGIN;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private aasConsumerManagerService: AasConsumerManagerService,
    private activedRoute: ActivatedRoute,
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private notiService: NotificationsService,
    public packageSessionService: PackageSessionService,
    private modalService: NgbModal,
    private alert: AlertControl
  ) { }

  ngOnInit(): void {
    // if (!GlobalConfig.ORIGIN_SERVICE.includes(location.hostname)) {
    //   this.router.navigate(['/login']);
    // }
    this.makeLoginForm();
    
  }

  ngAfterViewInit(): void {
    var videos = document.getElementsByTagName("video");
    for (var i = 0; i < videos.length; i++) {
      videos[i].muted = true;
      videos[i].play();
    } 
  }

  //MARK: Khởi tạo form login
  makeLoginForm() {
    this.loginForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.pattern(REGEXP_USERNAME)]),
      password: new FormControl(null, Validators.required)
    });
  }

  get email() { return this.loginForm.get('email') }
  get password() { return this.loginForm.get('password') }

  //MARK: Chức năng đăng nhập
  /**
   * Action đăng nhập
   */
  login() {
    this.isSubmit = true;
    this.loginFailed = false;
    this.clearSpace();
    if (this.loginForm.valid) {
      let domain = '';

      if (this.domain) domain = `${this.domain}.${GlobalConfig.HOST_SUBDOMAIN}`;
      else domain = LocationExtension.HOSTNAME;

      var param = {
        domain: domain,
        username: this.loginForm.value.email,
        password: this.loginForm.value.password,
        grant_type: "password",
        client_id: "clientapp",
        client_secret: "password"
      }

      this.postOauthToken(param);
    }
  }

  /**
   * Đăng nhập
   * @param param 
   */
  postOauthToken(param) {
    var result: any;
    this.isLoading = true;
    this.authService.postOauthToken(param).subscribe((res: any) => {
      result = new AuthLoginResponse(res);
      this.authService.setKey(result.key);

      this.token = new AuthLoginResponse(res);
      let jwtToken = this.authService.jwtDecode(this.token.access_token);

      // this.packageSessionService.setPackageSessionInfo({
      //   packageExpired: this.token.packageExpired,
      //   packageName: this.token.packageName
      // });

      if (this.saveLogin) {
        this.authService.setToken(this.token.access_token);
        this.authService.setUserId(jwtToken.idUser);
        this.authService.setUsername(jwtToken.user_name);
        localStorage.setItem(ConstLocalStorage.REFRESH_TOKEN, result.refresh_token);
      } else {
        this.authService.setSessionToken(this.token.access_token);
        this.authService.setSessionUserId(jwtToken.idUser);
        this.authService.setSessionUsername(jwtToken.user_name);
      }

      this.getUserInfo(this.authService.jwtDecode(this.authService.getToken()).idUser);
    }, err => {
      if (err['status'] === 401 || err['status'] === 400) {
        if (err.error.message && ['COE-00000008','COE-00000009'].includes(err.error.message)) {
          let errSplit = err.error.error?.toString().split('|');
          this.alert.showAlertOnlyNoti(errSplit[0],'error');
        } else {
          this.loginFailed = true;
        }
      } 

      this.authService.removeAllLocalStorage();
      this.isLoading = false;
    });
  }

  /**
   * Lấy thông tin user đăng nhập
   * @param id 
   */
  getUserInfo(id) {
    this.authService.getUserInfo(id).subscribe((res: any) => {
      this.userInfo = new UserInformationsResponse(res);
      this.authService.setUserInfo(new UserInformationsItem(res.object || {}));
      this.authService.internalPartyId = this.userInfo.object.partyId;
      this.authService.setPartyId(this.userInfo.object.referenceId || this.userInfo.object.partyId);

      this.getCheckTimeExpiredPackage(this.userInfo.object.partyId);
      // this.getInternalPartyInfo(this.userInfo.object.partyId);
      this.getPartyInfo(this.userInfo.object.referenceId);

      localStorage.setItem(ConstLocalStorage.USER_INFO, JSON.stringify(new UserInformationsItem(res?.object || {})));
      
      // Check if account is viewer to navigate contract-manager
      if (this.userInfo.object.isViewer == true) {
        this.directContractManager()
      } else {
        this.loginSuccess();
      }
    }, err => {
      this.handleError(err, ResponseMsg.MESSAGES.MANAGEMENT_SERVICE);
      this.loginSuccess();
    });
  }

  /**
   * Thong tin party dang login
   * @param partyId 
   */
  getInternalPartyInfo(partyId) {
    this.authService.getPartyInfo(partyId).subscribe((res: any) => {
    }, err => {
    });
  }

  /**
   * Thong tin party dang login
   * @param partyId 
   */
  getPartyInfo(partyId) {
    if (partyId == '' || partyId == null || partyId == undefined) {
      return;
    }
    this.authService.getPartyInfo(partyId).subscribe((res: any) => {
      this.authService.setPartyInfo(new InfoPartyObject(res.object || {}));
      localStorage.setItem(ConstLocalStorage.PARTY_INFO, JSON.stringify(new InfoPartyObject(res.object || {})));
    }, err => {
    });
  }

  loginSuccess() {
    var urlSplit = this.redirectUrl.split('/');
    urlSplit.splice(0, 3);
    const uuid = this.authService.jwtDecode(this.authService.getToken()).idUser;
    this.firebaseService.requestRegisterDevive(uuid);
    // this.firebaseService.requestPermissionAndRegisterDevice(uuid);
    this.redirectUrl !== '' ? this.router.navigateByUrl(urlSplit.join('/')) : this.router.navigate(['/app/console']);
    // const username = this.authService.jwtDecode(this.authService.getToken()).user_name;
    if (this.checkRoles || this.authService.username === "admin_aas") {
      this.router.navigate(['/console/report-customer']);
    } else {
      this.router.navigate(['/app/console']);
    }
  }


  get checkRoles() {
    const token = this.authService.getToken();
    const token_decode = this.authService.jwtDecode(token);
    const allowRoles = ['AAS_ADMIN']; //'KH_USER'
    const scope = ["AASADMIN"];

    let ok = false;

    token_decode.scope.forEach((item) => {
      if (scope.includes(item)) {
        ok = true;
      }
    })

    return ok;
  }

  //MARK: Trim value formControl
  clearSpace() {
    let str = `${this.email.value || ''}`;
    this.email.setValue(`${str.trim()}`);
  }

  //check Allow click
  get checkEdited() {
    if (this.password.value === '') return true;
    if (this.email.value === '') return true;
    return false;
  }

  /**
   * GET Check time expired package
   * @param partyId 
   */
  getCheckTimeExpiredPackage(partyId) {
    this.packageSessionService.getCheckTimeExpiredPackage(partyId).subscribe((res: any) => {
      this.packageSessionService.setPackageSessionInfo({
        packageExpired: res.object?.timeExpired || "",
        packageName: res.object?.packageName || "",
        packageType: res.object?.packageType || ""
      })
    }, err => {

    });
  }

  //MARK: Popup thông báo
  customAlert(msg, type, twoBtn = false, iconBtn2 = '', titleBtn2 = ConstantAlertBtn.OK, actBtn2 = () => { }, iconBtn1 = '', titleBtn1 = ConstantAlertBtn.CANCEL, actBtn1 = () => { }) {
    const modalRef = this.modalService.open(AlertComponent);
    modalRef.componentInstance.message = msg;
    modalRef.componentInstance.typeAlert = type;
    modalRef.componentInstance.twoBtn = twoBtn;
    modalRef.componentInstance.iconBtn1 = iconBtn1;
    modalRef.componentInstance.iconBtn2 = iconBtn2;
    modalRef.componentInstance.titleButton1 = titleBtn1;
    modalRef.componentInstance.titleButton2 = titleBtn2;
    modalRef.componentInstance.callback1 = actBtn1;
    modalRef.componentInstance.callback2 = actBtn2;
  }

  //MARK: Handle Error
  handleError(err, errorMsg) {
    if (err.error && err.error.message && errorMsg[err.error.message]) {
      this.customAlert(errorMsg[err.error.message], ConstantAlertType.ERROR);
    } else if (err.error && err.error.error) {
      this.customAlert(err.error.error, ConstantAlertType.ERROR);
    } else {
      this.customAlert(ConstantAlertMsg.DEFAULT_ERROR_REQUEST, ConstantAlertType.ERROR);
    }
  }

  directContractManager() {
    var urlSplit = this.redirectUrl.split('/');
    urlSplit.splice(0, 3);
    const uuid = this.authService.jwtDecode(this.authService.getToken()).idUser;
    this.firebaseService.requestRegisterDevive(uuid);
    this.router.navigate(['/app/console/contract-manager']);
  }
}
